import React from 'react';
import { Route, Routes } from 'react-router-dom';
import InvoicesListPage from './InvoicesListPage';

export default function InvoicesRoutes() {
  return (
    <Routes>
      <Route index element={<InvoicesListPage />} />
    </Routes>
  );
}
